import { useState } from 'react';
import {
    Box,
    FormControl,
    FormErrorMessage,
    FormLabel,
    Stack,
    VStack,
} from '@chakra-ui/react';
import { Field } from 'formik';
import { Select } from 'chakra-react-select';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    formLabelStyling,
    stackSpacing,
    stackStyling,
    dropDownFormStyle,
} from 'components/forms/new/formStyles';
import walkthroughIds from '../walkthroughIds';

const NONE_OPTION = { value: '', label: '— None (root level)' };

const ParentField = ({
    errors,
    touched,
    darkMode,
    catalogItems = [],
    excludeId,
}) => {
    const [isHovered, setIsHovered] = useState(false);

    const options = [
        NONE_OPTION,
        ...catalogItems
            .filter((item) => item.id !== excludeId)
            .map((item) => ({ value: item.id, label: item.name })),
    ];

    const chakraStyles = dropDownFormStyle(darkMode);

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={!!errors.parentId && touched.parentId}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()}>
                <FormLabel sx={formLabelStyling(darkMode)}>Parent</FormLabel>
                <Field name="parentId">
                    {({ field, form }) => {
                        const selected =
                            options.find((o) => o.value === field.value) ||
                            NONE_OPTION;
                        return (
                            <Box
                                sx={{
                                    display: 'flex',
                                    width: '100%',
                                    alignItems: 'flex-start',
                                    paddingTop: '15px',
                                }}>
                                <VStack width="100%" alignItems="normal">
                                    <Select
                                        options={options}
                                        value={selected}
                                        onChange={(opt) => {
                                            form.setFieldValue(
                                                'parentId',
                                                opt?.value || '',
                                            );
                                            if (!opt?.value) {
                                                form.setFieldValue('rule', '');
                                            }
                                        }}
                                        chakraStyles={chakraStyles}
                                        selectedOptionColor="brand"
                                        data-walkthroughid={
                                            walkthroughIds.createMode
                                                .ufParentSelect
                                        }
                                    />
                                    {errors.parentId && touched.parentId && (
                                        <FormErrorMessage
                                            sx={{
                                                marginTop: '0 !important',
                                                fontSize: '10px',
                                            }}
                                            justifyContent="flex-end">
                                            {errors.parentId}
                                        </FormErrorMessage>
                                    )}
                                </VStack>
                            </Box>
                        );
                    }}
                </Field>
                {isHovered && (
                    <FieldToolTip
                        label="No parent → top level. Otherwise nested beneath the chosen offering."
                        ariaLabel="catalog-parent-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default ParentField;
